import React from "react";
import { useLang } from "@/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "How long do reports take?", a: "Most routine tests are delivered the same day. Specialised tests may take 24–48 hours. Reports are shared digitally on WhatsApp and email." },
  { q: "Do I need fasting?", a: "Some tests like Blood Sugar (Fasting), Lipid Profile and certain wellness packages require 8–12 hours of fasting. Our team will guide you when you book." },
  { q: "Can samples be collected at home?", a: "Yes. Our trained, certified technicians collect your sample safely from your home. Book home collection online or via WhatsApp." },
  { q: "How do I receive my report?", a: "Digital reports are sent securely to your WhatsApp and email. Printed copies can also be collected from the laboratory." },
  { q: "How can I book an appointment?", a: "Click any 'Book a Test' button, call us at +91 89683 48800, or message us on WhatsApp. Walk-ins are also welcome during working hours." },
];

export default function FAQ() {
  const { t } = useLang();
  return (
    <section id="faq" className="py-20 md:py-28 bg-slate-50/60" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <div className="text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-turq-dark">{t("faq_label")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-3 tracking-tight">{t("faq_title")}</h2>
        </div>
        <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-2xl border border-slate-100 px-6 shadow-[0_10px_40px_-20px_rgba(0,0,0,0.08)]" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-heading font-semibold text-navy hover:no-underline py-5">{f.q}</AccordionTrigger>
              <AccordionContent className="text-secondary leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
